<div class="content flex-fill d-flex flex-column">
<div mat-dialog-content>
    <mat-tab-group [selectedIndex]="0" class="flex-fill" (selectedTabChange)="displayTable = false; setupData()">
        <mat-tab label="Case">
            <ng-template matTabContent>
                <mrs-table [data]="caseFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="caseFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Conversion">
            <ng-template matTabContent>
                <mrs-table [data]="conversionFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="conversionFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Date">
            <ng-template matTabContent>
                <mrs-table [data]="dateFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="dateFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Logical">
            <ng-template matTabContent>
                <mrs-table [data]="logicalFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="logicalFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Math">
            <ng-template matTabContent>
                <mrs-table [data]="mathFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="mathFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="String">
            <ng-template matTabContent>
                <mrs-table [data]="stringFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="stringFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Values">
            <ng-template matTabContent>
                <mrs-table [data]="valueFunctionDataSource" [initialSort]="initialSort" [displayedColumns]="valueFunctionColumns" *ngIf="displayTable">
                </mrs-table>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
<mat-dialog-actions align="end">
    <mrs-btn-tertiary buttonLabel="Close" buttonId="cancelButton" mat-dialog-close>Close</mrs-btn-tertiary>
</mat-dialog-actions>
</div>